export const STATUSES_ARRAY = [
  ["Aktywny", "active"],
  ["Oczekujący", "pending"],
  ["Dezaktywowany", "deactivate"],
]
